import React from 'react'

const Component: React.FC<{ str: string }> = ({ str }) => {
  const strArray = str.split(/\r\n|\n/)
  return (
    <>
      {strArray.map((s, key) => (
        // eslint-disable-next-line react/no-array-index-key
        <React.Fragment key={key}>
          {s}
          {key !== strArray.length - 1 && <br />}
        </React.Fragment>
      ))}
    </>
  )
}

export default Component
